import actionTypes from '../constants/action-types';

const createMediaGalleryAssets = (data, config, resolve, reject) => ({
  type: actionTypes.CREATE_MEDIA_GALLERY_ASSETS,
  payload: {
    data,
    config,
    resolve,
    reject,
  },
});

export default createMediaGalleryAssets;
